

import VenueSpaceCard from "./VenueSpaceCard";
import VenueSpaceGallery from "./VenueSpaceGallery";
import styles from "./VenueSpaces.module.css";

export default function VenueSpaces({ spaces }) {
  if (!spaces || spaces.length === 0) {
    return null;
  }

  const sortedSpaces = [...spaces].sort((a, b) =>
    (a.space_type || "").trim().localeCompare(
      (b.space_type || "").trim(),
      undefined,
      { sensitivity: "base" }
    )
  );

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>
        Other Event Spaces
      </h2>

      <div className={styles.contentLayout}>

        <div className={styles.gridWrapper}>
          <div className={styles.grid}>
            {sortedSpaces.map((space) => (
              <VenueSpaceCard
                key={space.id}
                space={space}
              />
            ))}
          </div>
        </div>

        <div className={styles.galleryWrapper}>
          <VenueSpaceGallery spaces={sortedSpaces} />
        </div>

      </div>
    </section>
  );
}